import { default as types } from "./types";

const {
  ADD_CONTRACT_REQUEST,
  ADD_CONTRACT_SUCCESS,
  ADD_CONTRACT_FAILURE,
  EDIT_CONTRACT_REQUEST,
  EDIT_CONTRACT_SUCCESS,
  EDIT_CONTRACT_FAILURE,
  DELETE_CONTRACT_REQUEST,
  DELETE_CONTRACT_SUCCESS,
  DELETE_CONTRACT_FAILURE,
  FETCH_CONTRACTS_REQUEST,
  FETCH_CONTRACTS_SUCCESS,
  FETCH_CONTRACTS_FAILURE,
} = types;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CONTRACT_REQUEST:
    case EDIT_CONTRACT_REQUEST:
    case DELETE_CONTRACT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_CONTRACT_SUCCESS:
    case EDIT_CONTRACT_SUCCESS:
    case DELETE_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_CONTRACT_FAILURE:
    case EDIT_CONTRACT_FAILURE:
    case DELETE_CONTRACT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_CONTRACTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_CONTRACTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_CONTRACTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
